import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LimitItem } from '@shared/models';
import { CurrencySignPipe } from '@shared/pipes';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-transaction-limit-item',
  templateUrl: './transaction-limit-item.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxMaskPipe, CommonModule, CurrencySignPipe],
})
export class TransactionLimitItemComponent {
  @Input() limitItem!: LimitItem;
}
